import { apiClient } from './client';

export interface SystemBehaviorConfig {
  porcinoWarehouseMode: 'SHARED' | 'SEPARATE' | 'BOTH';
  porcinoReportMode:    'INTEGRATED' | 'SEPARATE';
  budgetBlockMode:      'SOFT' | 'HARD';
}

export const fetchSystemBehavior = async (): Promise<SystemBehaviorConfig> =>
  (await apiClient.get('/api/config/behavior')).data;

export const updateSystemBehavior = async (data: Partial<SystemBehaviorConfig>): Promise<SystemBehaviorConfig> =>
  (await apiClient.put('/api/config/behavior', data)).data;

export type AiProviderId = 'gemini' | 'openai' | 'groq' | 'deepseek' | 'mistral' | 'cerebras' | 'openrouter' | 'cloudflare';

export interface AiProvidersConfig {
  preset:   'COST' | 'SPEED' | 'CUSTOM';
  order:    AiProviderId[];
  disabled: AiProviderId[];
}

export interface RanchoBehaviorConfig {
  porcinoWarehouseMode: 'SHARED' | 'SEPARATE' | 'BOTH';
  porcinoReportMode: 'INTEGRATED' | 'SEPARATE';
  budgetBlockMode: 'SOFT' | 'HARD';
}

export const fetchRanchoBehavior = async (ranchoId: string): Promise<RanchoBehaviorConfig> =>
  (await apiClient.get(`/api/config/behavior/${ranchoId}`)).data;

export const updateRanchoBehavior = async (ranchoId: string, data: Partial<RanchoBehaviorConfig>): Promise<RanchoBehaviorConfig> =>
  (await apiClient.put(`/api/config/behavior/${ranchoId}`, data)).data;

export const fetchAiProvidersConfig = async (): Promise<AiProvidersConfig> =>
  (await apiClient.get('/api/config/ai-providers')).data;

export const updateAiProvidersConfig = async (data: AiProvidersConfig): Promise<AiProvidersConfig> =>
  (await apiClient.put('/api/config/ai-providers', data)).data;

// ─── Rancho CRUD ──────────────────────────────────────────────────────────────

export interface Rancho {
  ranchoId:  string;
  tenantId:  string;
  name:      string;
  ubicacion?: string;
  hectareas?: number;
  latitude?:  number;
  longitude?: number;
  usesFarmModules?: boolean;
  status?:   string;
  createdAt?: string;
}

export interface RanchoInput {
  name:       string;
  ubicacion?: string;
  hectareas?: number;
  latitude?:  number;
  longitude?: number;
  usesFarmModules?: boolean;
}

export const fetchRanchos = async (): Promise<Rancho[]> =>
  (await apiClient.get('/api/ranchos')).data;

export const createRancho = async (input: RanchoInput): Promise<Rancho> =>
  (await apiClient.post('/api/ranchos', input)).data;

export const updateRancho = async (ranchoId: string, input: Partial<RanchoInput>): Promise<void> =>
  (await apiClient.put(`/api/ranchos/${ranchoId}`, input)).data;

export const deleteRancho = async (ranchoId: string): Promise<void> =>
  (await apiClient.delete(`/api/ranchos/${ranchoId}`)).data;

// ─── Warehouse CRUD ───────────────────────────────────────────────────────────

export interface Warehouse {
  warehouseId: string;
  name:        string;
  ranchoId?:   string | null;
  ubicacion?:  string | null;
}

export interface WarehouseInput {
  name:       string;
  ranchoId?:  string;
  ubicacion?: string;
}

export const createWarehouse = async (input: WarehouseInput): Promise<Warehouse> =>
  (await apiClient.post('/api/warehouses', input)).data;

export interface WarehouseUpdateInput {
  name?:     string;
  /** null = bodega compartida de empresa */
  ranchoId?: string | null;
}

export const updateWarehouse = async (warehouseId: string, input: WarehouseUpdateInput): Promise<Warehouse> =>
  (await apiClient.put(`/api/warehouses/${warehouseId}`, input)).data;

export const deleteWarehouse = async (warehouseId: string): Promise<void> =>
  (await apiClient.delete(`/api/warehouses/${warehouseId}`)).data;
